import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import 'jquery';
import 'notify';
import { ComposeEmail } from '../../form-components/compose-email/compose-email';

@autoinject
export class ComposeEmailDialog {
    insertedBy: string;
    canEdit: boolean = true;
    noteNotFound: boolean;
    context: any;
    constructor(protected controller: DialogController) {
    }

    public emailComponent: ComposeEmail;

    async activate(params) {
        this.context = params;
    }
    attached() {
        this.emailComponent.context = this.context;
    }
    public async save() {
        try {
            await this.emailComponent.send();
            $["notify"]("Email sent", { className: "success", position: "top center" });
            this.controller.ok();
        } catch (e) {
            alert("Error sending email: " + e);
        }

    }
}